<section class="mat-typography">
    <router-outlet></router-outlet>
</section>
